'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    DrawerToPopover: ()=>DrawerToPopover
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const external_react_responsive_namespaceObject = require("react-responsive");
var external_react_responsive_default = /*#__PURE__*/ __webpack_require__.n(external_react_responsive_namespaceObject);
const index_cjs_namespaceObject = require("../Drawer/index.cjs");
const external_Popover_index_cjs_namespaceObject = require("../Popover/index.cjs");
const external_utils_index_cjs_namespaceObject = require("../../utils/index.cjs");
const constants_cjs_namespaceObject = require("../../utils/constants.cjs");
const CLEAN_PROPS = [
    'showCloseButton',
    'showDragHandle'
];
const DrawerToPopover = ({ defaultOpen, open, ...props })=>{
    const [isOpenState, setIsOpenState] = (0, external_react_namespaceObject.useState)(defaultOpen);
    (0, external_react_namespaceObject.useEffect)(()=>{
        setIsOpenState(defaultOpen || open);
    }, [
        defaultOpen,
        open
    ]);
    function handleOnOpenChange(open) {
        setIsOpenState(open);
        props.onOpenChange?.(open);
    }
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_react_responsive_default(), {
                maxWidth: constants_cjs_namespaceObject.TRANSFORMER_MAX_MOBILE_WIDTH_PX,
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.Drawer, {
                    ...props,
                    open: isOpenState,
                    onOpenChange: handleOnOpenChange,
                    fadeFromIndex: void 0,
                    size: props.drawerSize
                })
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_react_responsive_default(), {
                minWidth: constants_cjs_namespaceObject.TRANSFORMER_MIN_DESKTOP_WIDTH_PX,
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Popover_index_cjs_namespaceObject.Popover, {
                    ...(0, external_utils_index_cjs_namespaceObject.cleanProps)(props, CLEAN_PROPS),
                    open: isOpenState,
                    onOpenChange: handleOnOpenChange,
                    size: props.popoverSize,
                    openOnHover: false
                })
            })
        ]
    });
};
exports.DrawerToPopover = __webpack_exports__.DrawerToPopover;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "DrawerToPopover"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
